import { render, staticRenderFns } from "./PostComments.component.vue?vue&type=template&id=5f1cbc2f&"
import script from "./PostComments.component.vue?vue&type=script&lang=js&"
export * from "./PostComments.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports